import { Injectable, inject } from '@angular/core';
import { BehaviorSubject, Subscription } from 'rxjs';
import { HttpService } from './http.service';
import { tap } from 'rxjs/operators';
import { Product } from '@shared/models';

@Injectable()
export class OthersProductsService {
    private httpService = inject(HttpService);

    products$ = new BehaviorSubject<Product[] | null>(null);

    private subscriptions$ = new Subscription();

    /**
     * Dispatch
     */
    dispatch(ids: string[]): void {
        this.subscriptions$.add(
            this.httpService
                .getOthersProductsInCategory(ids)
                .pipe(tap((products) => this.products$.next(products)))
                .subscribe(),
        );
    }

    /**
     * Destroy all pending subscritpions
     */
    destroy(): void {
        this.subscriptions$.unsubscribe();
    }
}
